import type { Currency, Variant } from 'types';

const formatProductVariant = (variants: Variant[], currency?: Currency) =>
  variants.map((v) => ({
    id: v.id,
    // @ts-ignore
    image: typeof v.image === 'string' ? v.image : v.image?.originalSrc,
    images: v.images,
    option1: v.selectedOptions[0]?.value,
    option2: v.selectedOptions[1]?.value,
    option3: v.selectedOptions[2]?.value,
    price: v.price + (currency && currency.vat ? v.price * currency.vat : 0),
    selectedOptions: v.selectedOptions,
    title: v.title
  }));

export default formatProductVariant;
